module.exports = __webpack_public_path__ + "img/dynamic-6.7d22ad46.png";